export default __webpack_public_path__ + "static/media/IMG_0787.90fb56dc.jpg";